const Styles = {
    'SortIndicator': 'SortIndicator_SortIndicator--eee7ae42',
    'SortIndicator__Icon': 'SortIndicator_SortIndicator__Icon--5d2f25ab',
    'SortIndicator__Label': 'SortIndicator_SortIndicator__Label--3ecfabc8',
    'collapse': 'SortIndicator_collapse--2fa52a9b'
};

export default Styles;